
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec536"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec536"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $a2c460e84a39a9de$exports = {};
$parcel$extendImportMap({
    "5kyut": "star-outline.7004ba08.svg",
    "7ADPq": "star-filled.1517b0dd.svg",
    "ge8Jy": "318bb7a02ee3d_001.1c06402a.webp",
    "bBGnN": "318bb7a02ee3d_002.3db3000d.webp",
    "9neor": "318bb7a02ee3d_003.fc3f3802.webp",
    "fEGDT": "440cb845c72e1_001.bb809d1d.webp",
    "9S0qb": "440cb845c72e1_002.93f5cdff.webp",
    "2LeZI": "440cb845c72e1_003.ac7e525f.webp",
    "e8OTd": "57f82f074d9af_001.38b64493.webp",
    "hhTHL": "57f82f074d9af_002.e6561cde.webp",
    "jP7YM": "e1362a1c72141_001.1501f7a0.webp",
    "7Sx70": "e1362a1c72141_002.2a168a33.webp",
    "1AD6w": "b402c3a2a501a_001.5d97aeb6.webp",
    "SAad1": "51453ff801875_001.687e0296.webp",
    "kvwf0": "51453ff801875_002.d81349e8.webp",
    "60duY": "ec23f5702ae68_001.68afa0e7.webp",
    "k7mvC": "06f1a8efc291c_001.329671b7.webp",
    "fwipT": "be1d80cfd8008_001.6f0cb91e.webp",
    "e8jQk": "be1d80cfd8008_002.e58828d8.webp",
    "e5zLH": "be1d80cfd8008_003.3bfa91b2.webp",
    "9tkn6": "f35796a06df51_001.9fb3d59c.webp",
    "faIS0": "f35796a06df51_002.28d182a2.webp",
    "2C0im": "318bb7a02ee3d_001.0e8996bd.png",
    "6UnXO": "440cb845c72e1_001.27c5fd6f.png",
    "6PURS": "440cb845c72e1_002.200b35f7.png",
    "jBi3K": "440cb845c72e1_003.23dc4731.png",
    "d56dC": "57f82f074d9af_001.b547198b.png",
    "7mc30": "57f82f074d9af_002.b531673a.png",
    "g8lno": "e1362a1c72141_001.baa6998e.png",
    "aOTUv": "e1362a1c72141_002.f5127a08.png",
    "6Fgce": "b402c3a2a501a_001.add641d3.png",
    "d80ji": "51453ff801875_001.8a3c351c.png",
    "fKAg1": "51453ff801875_002.f46dfead.png",
    "3GVhg": "ec23f5702ae68_001.8caff056.png",
    "5z5sI": "06f1a8efc291c_001.68a1e9c7.png",
    "3VvcP": "be1d80cfd8008_001.eb980189.png",
    "60ISX": "be1d80cfd8008_002.4911f02b.png",
    "lnvPy": "be1d80cfd8008_003.c722305f.png",
    "jzAST": "f35796a06df51_001.f273a13f.png",
    "eW3GN": "f35796a06df51_002.ea7f5fdb.png"
});









































const $cd7783a0d9a617e4$export$5e8d0e068d84aae1 = [
    {
        title: "Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 100g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            }
        ],
        price: '4,200.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 50g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            }
        ],
        price: '2,100.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 30g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Ru\u0301t Lo\u0302ng Kho\u0302 laying in a basket"
            }
        ],
        price: '1,300.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tho\u0302 100g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Tho\u0302 laying in a basket next to gold flowers"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Tho\u0302 laying in a basket next to gold flowers"
            }
        ],
        price: '2,600.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tho\u0302 50g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Tho\u0302 laying in a basket "
            }
        ],
        price: '1,300.000 ',
        rating: 5
    },
    {
        title: "Cha\u0302n Ye\u0302\u0301n Ru\u0301t Lo\u0302ng 100g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Cha\u0302n Ye\u0302\u0301n Ru\u0301t Lo\u0302ng laying in a glass bowl"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Zoomed in picture of Cha\u0302n Ye\u0302\u0301n Ru\u0301t Lo\u0302ng"
            }
        ],
        price: '3,200.000 ',
        rating: 5
    },
    {
        title: "Cha\u0302n Ye\u0302\u0301n Tho\u0302 100g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Cha\u0302n Ye\u0302\u0301n Tho\u0302 placed in a gold container"
            }
        ],
        price: '2,200.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tinh Che\u0302\u0301 100g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying in a basket next to a card with pink flowers "
            }
        ],
        price: '3,600.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tinh Che\u0302\u0301 50g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying in bowl on top of white paper"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picture of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying in bowl on top of white paper"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Zoomed in picured of Ye\u0302\u0301n Tinh Che\u0302\u0301 laying on a blue mat"
            }
        ],
        price: '1,800.000 ',
        rating: 5
    },
    {
        title: "Ye\u0302\u0301n Tinh Che\u0302\u0301 30g",
        images: [
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picure of Ye\u0302\u0301n Tinh Che\u0302\u0301  laying in a clear plastic bowl"
            },
            {
                png: (0, {}),
                webp: (0, {}),
                desc: "Picure of Ye\u0302\u0301n Tinh Che\u0302\u0301  laying in a clear plastic bowl next to a red card"
            }
        ],
        price: '1,100.000 ',
        rating: 5
    }
];


///////////////////////////////////////////////////////////
// Nav global references
const $1ee2b6306238ec66$var$productHeadingEl = document.querySelector('.product-heading');
const $1ee2b6306238ec66$var$productSectionEL = document.querySelector('.section-product');
const $1ee2b6306238ec66$var$navMission = './index.html#mission';
const $1ee2b6306238ec66$var$navWhy = './index.html#why';
const $1ee2b6306238ec66$var$navProducts = './index.html#products';
const $1ee2b6306238ec66$var$navTestimonial = './index.html#testimonial-section';
const $1ee2b6306238ec66$var$navContact = './index.html#contact';
const $1ee2b6306238ec66$var$navHome = './index.html#header';
// Setting href for all pages
const $1ee2b6306238ec66$var$missionNodes = Array.from(document.querySelectorAll('.mission-link'));
$1ee2b6306238ec66$var$missionNodes.forEach((el)=>el.href = $1ee2b6306238ec66$var$navMission);
document.querySelector('.why-link').href = $1ee2b6306238ec66$var$navWhy;
document.querySelector('.products-link').href = $1ee2b6306238ec66$var$navProducts;
document.querySelector('.testimonial-link').href = $1ee2b6306238ec66$var$navTestimonial;
document.querySelector('.contact-link').href = $1ee2b6306238ec66$var$navContact;
document.querySelector('.footer-logo').href = $1ee2b6306238ec66$var$navHome;
document.querySelector('.logo-container').href = $1ee2b6306238ec66$var$navHome;
// Search bar defaults
document.getElementById('y-search').placeholder = "B\u1EA1n mu\u1ED1n t\xecm g\xec ...";
document.getElementById('y-search-mobile').placeholder = "B\u1EA1n mu\u1ED1n t\xecm g\xec ...";
const $1ee2b6306238ec66$var$updateProductView = ()=>{
    const previousProducts = Array.from(document.querySelectorAll('.product'));
    const productsContainer = document.querySelector('.product-container');
    $1ee2b6306238ec66$var$productHeadingEl.textContent = 'Search Results';
    previousProducts.forEach((el)=>{
        productsContainer.removeChild(el);
    });
};
document.getElementById('search-form').addEventListener('submit', function(e) {
    e.preventDefault();
    $1ee2b6306238ec66$var$updateProductView();
    if (!document.getElementById('y-search').value) return;
    document.getElementById('search-icon').style.display = 'none';
});
document.getElementById('search-form-mobile').addEventListener('submit', function(e) {
    e.preventDefault();
});
document.getElementById('y-search').addEventListener('search', function(e) {
    if (e.target.value.length > 2) {
        const searchResults = $1ee2b6306238ec66$var$products.loadSearch(e.target.value);
        if (!searchResults) $1ee2b6306238ec66$var$productHeadingEl.textContent = 'Search Results - Nothing Found';
    }
    // Clearing search results
    if (e.target.value === '') {
        document.getElementById('search-icon').style.display = 'inline-block';
        $1ee2b6306238ec66$var$updateProductView();
        $1ee2b6306238ec66$var$products.loadProducts();
        $1ee2b6306238ec66$var$productHeadingEl.textContent = "T\u1ED5 Y\u1EBFn";
    }
    $1ee2b6306238ec66$var$productSectionEL.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
    });
});
document.getElementById('y-search-mobile').addEventListener('search', function(e) {
    $1ee2b6306238ec66$var$updateProductView();
    if (e.target.value.length > 2) {
        const searchResults = $1ee2b6306238ec66$var$products.loadSearch(e.target.value);
        document.querySelector('.product-heading').textContent = 'Search Results';
        if (!searchResults) $1ee2b6306238ec66$var$productHeadingEl.textContent = 'Search Results - Nothing Found';
    }
    // Clearing search results
    if (e.target.value === '') {
        $1ee2b6306238ec66$var$updateProductView();
        $1ee2b6306238ec66$var$products.loadProducts();
        $1ee2b6306238ec66$var$productHeadingEl.textContent = "T\u1ED5 Y\u1EBFn";
    }
    $1ee2b6306238ec66$var$productSectionEL.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
    });
    $1ee2b6306238ec66$var$headerEl.classList.toggle('nav-open');
});
///////////////////////////////////////////////////////////
// Products
class $1ee2b6306238ec66$var$ProductImages {
    constructor(imgPng, imgWebp, imgdescription){
        this.imageSet = [
            imgWebp,
            imgPng
        ]; //[webp, png]
        this.imgdescription = imgdescription;
    }
}
class $1ee2b6306238ec66$var$Product {
    id = Math.random().toString(16).split('.').at(-1);
    constructor(ProductImages, title, rating, price){
        this.images = ProductImages;
        this.title = title;
        this.rating = rating;
        this.price = price;
    }
    _stars(rating) {
        const filledStarsAmt = Math.round(rating);
        const filledStarsTemplate = `<img src="${(0, {})}" class="product-icon-star" alt="Solid star icon"/>`;
        const emptyStarsTemplate = `<img src="${(0, {})}" class="product-icon-star" alt="Star icon outline"/>`;
        const elFilledStars = filledStarsTemplate.repeat(filledStarsAmt);
        const elOutlineStar = emptyStarsTemplate.repeat(5 - filledStarsAmt);
        return {
            elFilledStars: elFilledStars,
            elOutlineStar: elOutlineStar
        };
    }
    _pictureMarkup(png, webp, imgDesc) {
        const markup = `
    <picture class="product-picture-${this.id}">
    <source srcset="${webp}" type="image/webp"/>
    <source srcset="${png}" type="image/png"/>
    <img
      src="${png}"
      class="product-img"
      alt="${imgDesc}"/>
    </picture>
    `;
        return markup;
    }
    createMarkup() {
        const { elFilledStars: elFilledStars, elOutlineStar: elOutlineStar } = this._stars(this.rating);
        const productImgArr = this.images.map((el)=>({
                images: el.imageSet,
                alt: el.imgdescription
            }));
        const picturesEl = productImgArr.map((el)=>this._pictureMarkup(el.images[1], el.images[0], el.alt)).join('');
        // DEBUG -------
        console.log(productImgArr[0].images[0]);
        // -----------------
        let markup = `
    <div class="product">
    <div class="${this.id}Images product-img-container"> `;
        markup += picturesEl;
        markup += `
    </div>
    <div class="product-content">
      <p class="product-title">${this.title}</p>
      <ul class="product-attributes">
        <li class="product-attribute">
          ${elFilledStars}
          ${elOutlineStar}
        </li>
        <li class="product-attribute">
          <span class="product-description">${this.price}\u{20AB}</span>
        </li>
      </ul>
    </div>`;
        return markup;
    }
}
class $1ee2b6306238ec66$var$Products {
    constructor(products){
        this.products = products;
    }
    loadProducts() {
        this.products.forEach((p)=>{
            $1ee2b6306238ec66$var$productContainer.insertAdjacentHTML('beforeend', p.createMarkup());
        });
    }
    _search(searchStr) {
        const words = searchStr.split(' ').filter((w)=>w.length > 2);
        const filterEl = this.products.map(function(el) {
            const titleArray = el.title.split(' ').map((el)=>el.toLowerCase());
            return words.every((val)=>titleArray.includes(val.toLowerCase())) ? el : null;
        });
        return filterEl.filter((val)=>val !== null);
    }
    loadSearch(searchStr) {
        const queryItems = this._search(searchStr);
        if (queryItems.length > 0) {
            queryItems.forEach((p)=>{
                $1ee2b6306238ec66$var$productContainer.insertAdjacentHTML('beforeend', p.createMarkup());
            });
            return true;
        }
        if (!queryItems) return null;
    }
}
const $1ee2b6306238ec66$var$productContainer = document.querySelector('.product-container');
const $1ee2b6306238ec66$var$productItems = [];
if ($1ee2b6306238ec66$var$productContainer) (0, $cd7783a0d9a617e4$export$5e8d0e068d84aae1).forEach((prod)=>{
    const imgCnt = prod.images.length;
    const productImagesArr = [];
    for(let i = 0; i < imgCnt; i++)productImagesArr.push(new $1ee2b6306238ec66$var$ProductImages(prod.images[i].png, prod.images[i].webp, prod.images[i].desc));
    const productItem = new $1ee2b6306238ec66$var$Product(productImagesArr, prod.title, prod.rating, prod.price);
    $1ee2b6306238ec66$var$productItems.push(productItem);
});
const $1ee2b6306238ec66$var$products = new $1ee2b6306238ec66$var$Products($1ee2b6306238ec66$var$productItems);
// products.loadProducts();
// rotate product images
const $1ee2b6306238ec66$var$productSection = document.querySelector('.product-container');
const $1ee2b6306238ec66$var$intervalIds = [];
// Disabled due to packaging issues
// if (productSection) {
//   const productObserver = new IntersectionObserver(
//     function (entries) {
//       const ent = entries[0];
//       if (ent.isIntersecting === true) {
//         // Insert rotating func
//         productItems.forEach((item) => {
//           const delay = Math.trunc(Math.random() * (5000 - 4000) + 4000);
//           rotateProductImages(item.id, delay);
//         });
//       }
//       if (ent.isIntersecting === false) {
//         intervalIds.forEach((id) => clearInterval(id));
//         intervalIds.splice(0);
//       }
//     },
//     {
//       root: null,
//       threshold: 0,
//       rootMargin: '-80px',
//     },
//   );
//
//   productObserver.observe(productSection);
// }
const $1ee2b6306238ec66$var$rotateProductImages = function(productId, interval) {
    const pictures = document.querySelectorAll(`.product-picture-${productId}`);
    let currentIndex = 0;
    function showNextImage() {
        pictures[currentIndex].classList.remove('active');
        pictures[currentIndex].style.opacity = '0';
        currentIndex = (currentIndex + 1) % pictures.length;
        pictures[currentIndex].classList.add('active');
        pictures[currentIndex].style.opacity = '1';
    }
    function startImageTransition(interval) {
        pictures[currentIndex].classList.add('active');
        const intervalId = setInterval(showNextImage, interval);
        $1ee2b6306238ec66$var$intervalIds.push(intervalId);
    }
    startImageTransition(interval);
};
///////////////////////////////////////////////////////////
// Set current year
const $1ee2b6306238ec66$var$yearEl = document.querySelector('.year');
const $1ee2b6306238ec66$var$currentYear = new Date().getFullYear();
$1ee2b6306238ec66$var$yearEl.textContent = $1ee2b6306238ec66$var$currentYear;
///////////////////////////////////////////////////////////
// Make mobile navigation work
const $1ee2b6306238ec66$var$btnNavEl = document.querySelector('.btn-mobile-nav');
const $1ee2b6306238ec66$var$headerEl = document.querySelector('.header');
$1ee2b6306238ec66$var$btnNavEl.addEventListener('click', function() {
    setTimeout(()=>{
        $1ee2b6306238ec66$var$headerEl.classList.toggle('nav-open');
    }, 500);
});
const $1ee2b6306238ec66$var$navLinks = Array.from(document.querySelectorAll('.main-nav-link'));
$1ee2b6306238ec66$var$navLinks.forEach((link)=>{
    link.addEventListener('click', function(e) {
        $1ee2b6306238ec66$var$headerEl.classList.toggle('nav-open');
    });
});
///////////////////////////////////////////////////////////
// Smooth scrolling animation
const $1ee2b6306238ec66$var$allLinks = document.querySelectorAll('a:link');
$1ee2b6306238ec66$var$allLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
        const href = link.getAttribute('href');
        if (!href.startsWith('#')) return;
        e.preventDefault();
        // Scroll back to top
        if (href === '#') window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        // Scroll to other links
        if (href !== '#' && href.startsWith('#')) {
            const sectionEl = document.querySelector(href);
            sectionEl.scrollIntoView({
                behavior: 'smooth'
            });
        }
        // Close mobile naviagtion
        if (link.classList.contains('main-nav-link')) $1ee2b6306238ec66$var$headerEl.classList.toggle('nav-open');
    });
});
///////////////////////////////////////////////////////////
// Sticky navigation
const $1ee2b6306238ec66$var$sectionHeroEl = document.querySelector('.section-hero');
if ($1ee2b6306238ec66$var$sectionHeroEl) {
    const obs = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === false) document.body.classList.add('sticky');
        if (ent.isIntersecting === true) document.body.classList.remove('sticky');
    }, {
        root: null,
        threshold: 0,
        rootMargin: '-80px'
    });
    obs.observe($1ee2b6306238ec66$var$sectionHeroEl);
}
///////////////////////////////////////////////////////////
// Shrink contacts widget in Testimonials section
const $1ee2b6306238ec66$var$sectionTestimonialEl = document.querySelector('.section-testimonials');
const $1ee2b6306238ec66$var$widgetContainer = document.querySelector('.widget-container');
if ($1ee2b6306238ec66$var$widgetContainer) {
    const observer = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === false) $1ee2b6306238ec66$var$widgetContainer.classList.remove('widget-collapse');
        if (ent.isIntersecting === true) $1ee2b6306238ec66$var$widgetContainer.classList.add('widget-collapse');
    }, {
        root: null,
        threshold: 0,
        rootMargin: '-80px'
    });
    observer.observe($1ee2b6306238ec66$var$sectionTestimonialEl);
}
///////////////////////////////////////////////////////////
// Hide contacts widget on footer section
const $1ee2b6306238ec66$var$sectionFooterEl = document.querySelector('.footer');
if ($1ee2b6306238ec66$var$widgetContainer) {
    const observerFooter = new IntersectionObserver(function(entries) {
        const ent = entries[0];
        if (ent.isIntersecting === false) $1ee2b6306238ec66$var$widgetContainer.classList.remove('widgets-container-hide');
        if (ent.isIntersecting === true) $1ee2b6306238ec66$var$widgetContainer.classList.add('widgets-container-hide');
    }, {
        root: null,
        threshold: 0,
        rootMargin: '-100px'
    });
    observerFooter.observe($1ee2b6306238ec66$var$sectionFooterEl);
}
///////////////////////////////////////////////////////////
// Fixing flexbox gap property missing in some Safari versions
function $1ee2b6306238ec66$var$checkFlexGap() {
    const flex = document.createElement('div');
    flex.style.display = 'flex';
    flex.style.flexDirection = 'column';
    flex.style.rowGap = '1px';
    flex.appendChild(document.createElement('div'));
    flex.appendChild(document.createElement('div'));
    document.body.appendChild(flex);
    const isSupported = flex.scrollHeight === 1;
    flex.parentNode.removeChild(flex);
    if (!isSupported) document.body.classList.add('no-flexbox-gap');
}
$1ee2b6306238ec66$var$checkFlexGap();


//# sourceMappingURL=repo.01bc2337.js.map
